const initState = {
    loading: false,
    loadError: false,
    errorMsg: '',
    errorMsgData: '',
    customerData: [],
    customerSearchData: []
}

const customersReducer = (state = initState, action) => {
    switch (action.type) {
        case 'LOAD_CUSTOMER_DATA_STARTED':
            return {
                ...initState,
                loading: true
            }
        case 'LOAD_CUSTOMER_DATA_SUCCESS':
            return {
                ...initState,
                ...action.payload
            }
        case 'LOAD_CUSTOMER_DATA_ERROR':
            const { errorMsg, errorMsgData } = action.payload;
            return {
                ...initState,
                loadError: true,
                errorMsg,
                errorMsgData
            }
        default:
            return state;
    }
}

export default customersReducer;